
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { User } from "@/types";

interface PointsStatisticsProps {
  users: User[];
}

const PointsStatistics: React.FC<PointsStatisticsProps> = ({ users }) => {
  // Calculate total points
  const totalPoints = users.reduce((sum, user) => sum + (user.points || 0), 0);
  
  // Calculate average points per user
  const averagePoints = users.length > 0 ? Math.round(totalPoints / users.length) : 0;
  
  // Find user with most points
  const userWithMostPoints = users.reduce(
    (maxUser, user) => (!maxUser || (user.points || 0) > (maxUser.points || 0)) ? user : maxUser,
    null as User | null
  );
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <Card className="bg-brand-dark border-none">
        <CardContent className="pt-6">
          <div className="text-gray-400 text-sm">Total de Pontos</div>
          <div className="text-2xl font-bold">{totalPoints.toLocaleString()}</div>
        </CardContent>
      </Card>
      
      <Card className="bg-brand-dark border-none">
        <CardContent className="pt-6">
          <div className="text-gray-400 text-sm">Média de Pontos</div>
          <div className="text-2xl font-bold">{averagePoints.toLocaleString()}</div>
        </CardContent>
      </Card>
      
      <Card className="bg-brand-dark border-none">
        <CardContent className="pt-6">
          <div className="text-gray-400 text-sm">Utilizador com Mais Pontos</div>
          <div className="text-2xl font-bold">
            {userWithMostPoints ? (
              <>
                <span>{userWithMostPoints.name}</span>
                <span className="text-brand-red ml-2">
                  ({userWithMostPoints.points?.toLocaleString() || 0})
                </span>
              </>
            ) : (
              "Nenhum utilizador"
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PointsStatistics;
